import { ApiService } from '../apiService'

/**
 * The caller's group play in one list (`GET /api/me/group-play`, API MyGroupsController): adventure group invites still
 * unanswered, lobbies joined (planned ones with their date), groups under way, and Story parties. My Adventures'
 * Active tab shows it, so an invite can be found again after its notice is gone (owner 2026-10-15).
 */

export type MyGroupKind = 'adventureGroup' | 'storyParty'
export type MyGroupStatus = 'invited' | 'joined' | 'scheduled' | 'playing' | 'driving'
/** Where a click goes. The ids it needs are on the item. */
export type MyGroupTarget = 'lobby' | 'play' | 'story' | 'adventure'

export interface MyGroupItemDto {
  kind: MyGroupKind
  status: MyGroupStatus
  sessionId: string | null
  partyId: string | null
  adventureId: string | null
  storyId: string | null
  /** The adventure's title, or the Story's name. */
  title: string
  thumbnailUrl: string | null
  /** A party's stop by name while it drives there or plays it. */
  stopTitle: string | null
  hostUserId: string
  hostName: string
  hostAvatarUrl: string | null
  isHost: boolean
  invitedByName: string | null
  scheduledStartDate: string | null
  memberCount: number
  since: string
  target: MyGroupTarget
}

export interface MyGroupsResponse {
  items: MyGroupItemDto[]
}

export const MY_GROUPS_QUERY_KEY = ['me', 'groups'] as const

export const groupPlayApi = {
  myGroups: () => ApiService.get<MyGroupsResponse>('/api/me/group-play'),
  /** Join a Story party I was invited to (starts the Story for me once the server says I can play). */
  acceptStoryParty: (partyId: string) => ApiService.post<unknown>(`/api/story-parties/${partyId}/accept`),
  declineStoryParty: (partyId: string) => ApiService.post<unknown>(`/api/story-parties/${partyId}/decline`),
}
